export default "__VITE_ASSET__DUfLekvn__"